export type AnalyticsEventName =
  | 'register'
  | 'create_site'
  | 'publish_site'
  | 'subscribe_success'
  | 'credits_purchase'
  | 'domain_purchase'
  | 'addon_purchase';

export const PAYMENT_GOAL_NAMES = [
  'subscribe_success',
  'credits_purchase',
  'domain_purchase',
  'addon_purchase',
] as const;

export type PaymentGoalName = (typeof PAYMENT_GOAL_NAMES)[number];

export interface AnalyticsRevenue {
  value: number;
  currency: string;
}

export interface AnalyticsEcommerceProduct {
  id: string;
  name: string;
  price: number;
  quantity?: number;
  category?: string;
  variant?: string;
}

export interface AnalyticsTrackEvent {
  name: AnalyticsEventName;
  props?: Record<string, string | number | boolean | null | undefined>;
  revenue?: AnalyticsRevenue;
  products?: AnalyticsEcommerceProduct[];
}

export interface AnalyticsPageContext {
  pagePath: string;
  pageLocation: string;
  title?: string;
  referrer?: string;
}

export interface AnalyticsConfig {
  yandexMetrikaId: number | null;
  googleTrackingCode?: string | null;
}

export interface AnalyticsProvider {
  page(ctx: AnalyticsPageContext): void;
  track(event: AnalyticsTrackEvent): void;
}
